export const serviceName = 'yclients'

export default { serviceName }
